/*
 * @Author: your name
 * @Date: 2021-04-01 17:30:36
 * @LastEditTime: 2022-02-14 10:07:58
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \hz-finances\src\api\common.js
 */
import request from "@/utils/request.js";

export const initMenu = data => {
  return request({
    url: "/HZ-USER-SERVER/menu_api/search/all_application",
    params: data || {}
  });
};
// export const getRouter = data => {
//   return request({
//     url: "/api/query/menuList",
//     params: data || {}
//   });
// };

export const getRouter = data => {
  return request({
    url: "/api/hz-smart-community/sys/menu/nav",
    params: data || {}
  });
};